import _ from 'lodash';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { inject, observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import SongSelector from 'common/components/song-selector';

const filterAlbumSongs = (albumSongs = [], tracksList) => {
	return tracksList.filter((song) => {
		return albumSongs.map(({ _id }) => _id).indexOf(song._id) === -1;
	});
};

@inject('songsStore', 'albumsStore')
@observer
class SongList extends Component {
	constructor (props) {
		super(props);

		const { songsStore, albumsStore } = this.props;
		const albumSongs = albumsStore.get('album.songs') || [];
		const songs = filterAlbumSongs(albumSongs, songsStore.songs);

		this.state = { songs, albumSongs };
	}

	render() {
		const { songsStore } = this.props;
		const { songs = [], albumSongs = [] } = this.state;
		const selectedSongs = _(albumSongs)
			.map((item) => _.isString(item) ? songsStore.getSongByID(item) : item)
			.compact()
			.value();

		return (
			<SongSelector
				addSong={ this.addSong }
				removeSong={ this.removeSong }
				onDragEnd={ this. onDragEnd }
				songList={ songs }
				selectedSongs={ selectedSongs } />
		);
	}

	@autobind
	onDragEnd ({ source: { index: startIndex }, destination: { index: endIndex } }) {
		const albumSongs = this.state.albumSongs.slice();
		const [ removed ] = albumSongs.splice(startIndex, 1);

		albumSongs.splice(endIndex, 0, removed);

		this.setState({ albumSongs });
		this.updateStore(albumSongs);
	}

	@autobind
	addSong (songID) {
		const albumSongs = this.state.albumSongs.concat(
			this.state.songs.filter(({ _id }) => _id === songID)
		);

		const songs = filterAlbumSongs(albumSongs,
			this.props.songsStore.songs);

		this.setState({ songs, albumSongs });
		this.updateStore(albumSongs);
	}

	@autobind
	removeSong (songID) {
		const albumSongs = this.state.albumSongs
			.filter(({ _id }) => _id !== songID);
		const songs = filterAlbumSongs(albumSongs,
			this.props.songsStore.songs);

		this.setState({ songs, albumSongs });
		this.updateStore(albumSongs);
	}

	updateStore (albumSongs) {
		const key = 'album.songs';
		const value = _(albumSongs)
			.map((item) => _.isString(item) ? item : item._id)
			.uniq()
			.compact()
			.value();

		console.log('[SongList.updateStore]', key, value);
		this.props.albumsStore.set({ key, value });
	}
}

export default SongList;
